import { render } from "./TabContent.vue?vue&type=template&id=1194a486"
import script from "./TabContent.vue?vue&type=script&lang=js"
export * from "./TabContent.vue?vue&type=script&lang=js"
script.render = render

export default script